<template>
  <div>
    <div id="editorHeader" class="ui grid">
      <div class="eight wide column">
        <div class="ui secondary disabled menu diffChangeLabel original">
          <div class="item" v-if="originalValue.ts">
            {{ formatDate(originalValue.ts) }}
          </div>
          <div class="right floated item" v-if="originalValue.tag">
            <diff-change-label :tagname="originalValue.tag" />
          </div>
        </div>
      </div>
      <div class="eight wide column">
        <div class="ui secondary disabled menu diffChangeLabel modified">
          <div class="item" v-if="modifiedValue.ts">
            {{ formatDate(modifiedValue.ts) }}
          </div>
          <div class="right floated item" v-if="modifiedValue.tag">
            <diff-change-label :tagname="modifiedValue.tag" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../../scss/variables';

#editorHeader {
  .diffChangeLabel {
    height: 3em;
    border-radius: 5px;

    &.original {
      box-shadow: inset 0 0 0 2px $purple;
      margin-left: 2em;
    }
    &.modified {
      box-shadow: inset 0 0 0 2px $yellow;
      margin-right: 2em;
    }
    overflow: hidden;
  }

  .changeIdentifier {
    max-width: 100%;
  }
}
</style>

<script>
// @flow
import DiffChangeLabel from '../../../Changelog/DiffChangeLabel'
import moment from 'moment'

export default {
  name: 'changelog-diff',
  components: { DiffChangeLabel },

  props: {
    originalValue: {
      type: Object,
      default: () => {}
    },
    modifiedValue: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    formatDate(ts) {
      if (!ts) return ''
      return moment(new Date(0).setUTCSeconds(ts))
        .locale(this.$locale.current())
        .format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>
